import React from "react";
import { Oval } from "react-loader-spinner";

const RouteLoader = () => {
  return (
    <div className="fullPgLoaderWrap">
      <div className="loaderWrap">
        <Oval color="#3498DB" />
        <p>Loading...</p>
      </div>
    </div>
  );
};

export default RouteLoader;
